const TabContent = ({ heading }: any) => {
  return (
    <div className="w-100% bg-white pt-[9.391rem] pb-[95.184rem] rounded-[2.09733rem] pl-[5.5rem] pr-[11.352rem] mt-[4.25rem]">
      {/* <div className="bg-[#fff] py-[1.7rem] pl-[2.8rem] pr-[1.8rem] sm:py-[5.3rem] sm:px-[7rem] mt-[4.25rem] sm:mt-[4.5rem] sm:rounded-[2rem] rounded-[0.67rem]"> */}
      <h1 className="font-medium text-[#333333] text-[5rem]">{heading}</h1>
      <div id="swot_tabs">
        <h3 className="text-[#333333] text-[3.5rem] mt-[8.5rem]">
          Sorem ipsum dolor sit amet, consectetur adipiscing elit. Etiam eu
          turpis molestie, dictum est a, mattis tellus. Sed dignissim, metus nec
          fringilla accumsan, risus sem sollicitudin lacus, ut interdum tellus
          elit sed risus. Maecenas eget condimentum velit, sit amet feugiat
          lectus. Class aptent taciti sociosqu ad litora torquent per conubia
          nostra, per inceptos himenaeos. Praesent auctor purus luctus enim
          egestas, ac scelerisque ante pulvinar. Donec ut rhoncus.
        </h3>
      </div>
    </div>
    // </div>
  );
};

export default TabContent;
